import { render, staticRenderFns } from "./CondoSaleLine.vue?vue&type=template&id=195ea87d&scoped=true"
import script from "./CondoSaleLine.vue?vue&type=script&lang=js"
export * from "./CondoSaleLine.vue?vue&type=script&lang=js"
import style0 from "./CondoSaleLine.vue?vue&type=style&index=0&id=195ea87d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195ea87d",
  null
  
)

export default component.exports